import React, {forwardRef} from "react"
import {Box} from "@mui/material"

const HiddenCanvas = forwardRef<HTMLCanvasElement>((_, ref) => (
  <Box
    component="canvas"
    ref={ref}
    sx={{overflow: "hidden", visibility: "hidden", position: "fixed"}}
  />
))

HiddenCanvas.displayName = "HiddenCanvas"

export default HiddenCanvas
